'use strict';

export default class AlarmCloseActionsComponent {
  constructor() {
    this.restrict = 'E'
    this.template = require('./alarm.closeactions.component.html'),
      this.scope = {
        alarm: '='
      }
  }
  controller() {
  }
}